import React, { useState } from 'react';
import StepShell from './StepShell';
import FieldStack, { ChoiceCard } from './FieldStack';
import { SelectField } from '../../../ui/select-field';
import { Alert, AlertDescription, AlertTitle } from '../../../ui/alert';
import { SELF_GEN_OPTIONS } from '../../fixtures';
import { Leaf, Zap, HelpCircle, Sun, Info } from 'lucide-react';

const RenewableEnergy = () => {
  const [tariff, setTariff] = useState(null);
  const [selfGen, setSelfGen] = useState('no');
  const [genShare, setGenShare] = useState('25-50');

  return (
    <StepShell
      title='Where does your electricity come from?'
      description='Lets us apply the right emission factor to your home electricity use.'>
      <FieldStack label='Is your home electricity on a certified renewable tariff?' required>
        <div className='space-y-2'>
          <ChoiceCard
            active={tariff === 'yes'}
            icon={Leaf}
            label='Yes — 100% renewable tariff'
            desc='e.g. Octopus Go, Good Energy, Bulb Green'
            onClick={() => setTariff('yes')}
          />
          <ChoiceCard
            active={tariff === 'no'}
            icon={Zap}
            label='No — standard tariff'
            onClick={() => setTariff('no')}
          />
          <ChoiceCard
            active={tariff === 'unknown'}
            icon={HelpCircle}
            label="I don't know"
            desc="We'll use the national grid average"
            onClick={() => setTariff('unknown')}
          />
        </div>
      </FieldStack>

      <FieldStack label='Do you have solar panels or other self-generation at home?' required>
        <div className='grid grid-cols-2 gap-2'>
          <ChoiceCard active={selfGen === 'yes'} icon={Sun} label='Yes' onClick={() => setSelfGen('yes')} />
          <ChoiceCard active={selfGen === 'no'} label='No' onClick={() => setSelfGen('no')} />
        </div>
      </FieldStack>

      {selfGen === 'yes' && (
        <FieldStack
          label='What share of your daytime electricity comes from your own generation?'
          hint='Rough estimate is fine'>
          <SelectField
            options={SELF_GEN_OPTIONS}
            value={genShare}
            onChange={setGenShare}
            placeholder='Pick a range...'
            className='mb-0'
          />
        </FieldStack>
      )}

      {tariff === 'yes' && (
        <Alert>
          <Info size={14} strokeWidth={1.5} />
          <AlertTitle>100% renewable tariff</AlertTitle>
          <AlertDescription>
            We'll apply a market-based renewable factor to your home electricity — typically this produces near-zero
            emissions for that portion.
          </AlertDescription>
        </Alert>
      )}
    </StepShell>
  );
};

export default RenewableEnergy;
